import { CheckIcon, XIcon, VehicleIcon } from '../Layout/icons';
import {
    getRouteStatusDisplayLabel,
    getRouteStatusValue,
    normalizeRouteStatusValue,
    ROUTE_STATUS,
    ROUTE_STATUS_LABEL,
} from '../../services/routeService';

/**
 * Estilo visual dos status de roteiro — mesmo padrão de layout que {@link ../Deliveries/statusConfig.js}
 * (badge com ícone opcional, data-color-token, largura mínima em tabelas).
 */
export const ROUTE_STATUS_STYLE_MAP = {
    [ROUTE_STATUS.CREATION]: {
        label: ROUTE_STATUS_LABEL[ROUTE_STATUS.CREATION],
        colorToken: 'gray',
        icon: null,
    },
    IN_CREATION: {
        label: ROUTE_STATUS_LABEL[ROUTE_STATUS.CREATION],
        colorToken: 'gray',
        icon: null,
    },
    [ROUTE_STATUS.PENDING]: {
        label: ROUTE_STATUS_LABEL[ROUTE_STATUS.PENDING],
        colorToken: 'indigo',
        icon: null,
    },
    [ROUTE_STATUS.IN_PROGRESS]: {
        label: ROUTE_STATUS_LABEL[ROUTE_STATUS.IN_PROGRESS],
        colorToken: 'blue',
        icon: VehicleIcon,
    },
    [ROUTE_STATUS.FINISHED]: {
        label: ROUTE_STATUS_LABEL[ROUTE_STATUS.FINISHED],
        colorToken: 'green',
        icon: CheckIcon,
    },
    [ROUTE_STATUS.CANCELLED]: {
        label: ROUTE_STATUS_LABEL[ROUTE_STATUS.CANCELLED],
        colorToken: 'red',
        icon: XIcon,
    },
};

export { getRouteStatusValue };

export function getRouteStatusMeta(apiStateOrValue) {
    const value = getRouteStatusValue(apiStateOrValue);
    const normalizedValue = normalizeRouteStatusValue(value);
    const apiLabel =
        typeof apiStateOrValue === 'object' && apiStateOrValue?.status
            ? String(apiStateOrValue.status)
            : null;
    const meta = ROUTE_STATUS_STYLE_MAP[normalizedValue] || ROUTE_STATUS_STYLE_MAP[value];
    if (!meta) {
        return {
            value,
            label: apiLabel || getRouteStatusDisplayLabel(value),
            colorToken: 'gray',
            icon: null,
        };
    }
    return { value, ...meta, label: apiLabel || meta.label };
}
